import { useCallback, useMemo, useState } from 'react'
import useQuestionField from '@v4/hooks/questions/useQuestionField'
import useQuestionSettingsField from '@v4/hooks/questions/useQuestionSettingsField'
import QuizQuestionsSelector from '@v4/utils/selectors/QuizQuestionsSelector'
import useStyles from './YesNoButtons.styled'

export const useYesNoButtons = props => {
	const { onClick, pending, justify, questionId } = props
	const options = useQuestionField(questionId, 'options')
	const showMaybeAnswer = useQuestionSettingsField('maybe_answer')
	const { updateQuestionOption } = QuizQuestionsSelector.useActions()

	const classes = useStyles()

	const [selectedValue, setSelectedValue] = useState(null)

	const handleClick = useCallback(
		({ optionId }) => {
			setSelectedValue(optionId)
			onClick({ options: [optionId] })
		},
		[onClick],
	)

	const handleChange = useCallback(
		option => {
			updateQuestionOption({ questionId, option })
		},
		[questionId, updateQuestionOption],
	)

	const filteredOptions = useMemo(() => (showMaybeAnswer ?? true ? options : _.slice(options, 0, 2)), [
		options,
		showMaybeAnswer,
	])

	return [
		{ classes, justify, options: filteredOptions, pending, selectedValue },
		{ handleClick, handleChange },
	]
}
